import usePushRegistration from '../hooks/usePushRegistration';

/**
 * PushRegistrar
 * Renders nothing. Mounted inside the Clerk-authenticated tree so the
 * push-registration hook can call `getToken()` once a session exists.
 *
 * Lives in App.js next to <Routes> so it's mounted exactly once per app load.
 */
const PushRegistrar = () => {
  usePushRegistration();
  return null;
};

export default PushRegistrar;
